module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://shadow.zhaogangimg.com/assets/zgkaihu/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 143);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.number.constructor");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.regexp.exec");

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/kaihu-sms-code/src/main.vue?vue&type=template&id=058d901e&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "kaihu-sms-code",
      attrs: {
        visible: _vm.visible,
        title: "手机验证码",
        width: "440px",
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        open: _vm.handleOpened,
        close: function($event) {
          return _vm.$emit("update:visible", false)
        }
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c("span", { staticClass: "title" }, [_vm._v("手机验证码")])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", [
        _vm.desc
          ? _c("div", { staticClass: "desc" }, [
              _vm._v("\n      " + _vm._s(_vm.desc) + "\n    ")
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "kaihu-sms-code-content" },
          [
            _vm._l(_vm.codeArr, function(item, index) {
              return _c(
                "label",
                {
                  key: index,
                  staticClass: "kaihu-sms-code-label",
                  class: { animated: _vm.focused && _vm.cursorIndex === index },
                  style: { marginLeft: index > 0 ? "12px" : "0px" },
                  attrs: { for: "code" }
                },
                [_vm._v("\n        " + _vm._s(item) + "\n      ")]
              )
            }),
            _c("el-input", {
              ref: "input",
              staticClass: "input",
              attrs: {
                id: "code",
                value: _vm.smsCode,
                maxlength: _vm.maxlength
              },
              on: {
                input: _vm.handleInput,
                focus: function($event) {
                  _vm.focused = true
                },
                blur: function($event) {
                  _vm.focused = false
                }
              }
            })
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "kaihu-sms-code-bottom" },
          [
            _vm.countDownNum > 0
              ? _c("span", [_vm._v(_vm._s(_vm.countDownNum) + "后重新获取")])
              : _c(
                  "el-button",
                  {
                    staticClass: "button",
                    attrs: { type: "text" },
                    on: { click: _vm.handleResetClick }
                  },
                  [_vm._v("\n        重新获取验证码\n      ")]
                )
          ],
          1
        ),
        _vm.text
          ? _c("div", { staticClass: "status" }, [
              _c("i", {
                class: {
                  "el-icon-success": _vm.status === "success",
                  "el-icon-warning": _vm.status === "error",
                  "is-success": _vm.status === "success",
                  "is-error": _vm.status === "error"
                }
              }),
              _c(
                "span",
                {
                  class: {
                    "text-success": _vm.status === "success",
                    "text-error": _vm.status === "error"
                  }
                },
                [_vm._v("\n        " + _vm._s(_vm.text) + "\n      ")]
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/kaihu-sms-code/src/main.vue?vue&type=template&id=058d901e&

// EXTERNAL MODULE: external "core-js/modules/es.number.constructor"
var es_number_constructor_ = __webpack_require__(10);

// EXTERNAL MODULE: external "core-js/modules/es.regexp.exec"
var es_regexp_exec_ = __webpack_require__(11);

// EXTERNAL MODULE: external "core-js/modules/es.string.match"
var es_string_match_ = __webpack_require__(45);

// EXTERNAL MODULE: external "core-js/modules/es.string.split"
var es_string_split_ = __webpack_require__(32);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/kaihu-sms-code/src/main.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var DEFAULT_COUNT_DOWN_NUMBER = 60;
var DEFAULT_MAX_LENGTH = 4;
/* harmony default export */ var mainvue_type_script_lang_js_ = ({
  name: 'KaihuSmsCode',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
      default: DEFAULT_MAX_LENGTH
    },
    countDown: {
      type: Number,
      default: DEFAULT_COUNT_DOWN_NUMBER
    },
    startDown: {
      type: Boolean,
      default: true
    },
    desc: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      smsCode: '',
      focused: false,
      countDownId: null,
      countDownNum: DEFAULT_COUNT_DOWN_NUMBER,
      status: '',
      text: ''
    };
  },
  computed: {
    codeArr: function codeArr() {
      var arr = this.smsCode.split('');

      while (arr.length < this.maxlength) {
        arr.push('');
      }

      return arr;
    },
    cursorIndex: function cursorIndex() {
      return this.smsCode.length;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.stopCountDown();
  },
  methods: {
    handleInput: function handleInput(val) {
      if (val) {
        var match = val.match(/^[0-9]*$/);

        if (match) {
          this.smsCode = match[0];

          if (this.smsCode.length === this.maxlength) {
            this.$refs.input.blur();
            this.$emit('finished', this.smsCode);
          }
        }
      } else {
        this.smsCode = '';
      }
    },
    clearSmsCode: function clearSmsCode() {
      this.smsCode = '';
    },
    resetCountDown: function resetCountDown() {
      this.countDownNum = this.countDown || DEFAULT_COUNT_DOWN_NUMBER;
      this.smsCode = '';
      this.focus();
      this.startCountDown();
    },
    startCountDown: function startCountDown() {
      var _this = this;

      if (this.countDownNum <= 0) {
        return;
      }

      this.stopCountDown();
      this.countDownId = setInterval(function () {
        _this.countDownNum = _this.countDownNum - 1;

        if (_this.countDownNum <= 0) {
          _this.stopCountDown();
        }
      }, 1000);
    },
    stopCountDown: function stopCountDown() {
      this.countDownId && clearInterval(this.countDownId);
    },
    handleResetClick: function handleResetClick() {
      this.$emit('reset');
      this.setStatusText('', '');
    },
    focus: function focus() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs.input.focus();
      });
    },
    setStatusText: function setStatusText(status, text) {
      this.status = status;
      this.text = text;
    },
    handleOpened: function handleOpened() {
      if (this.startDown) {
        this.resetCountDown();
      }

      this.status = '';
      this.text = '';
      this.smsCode = '';
      this.focus();
    }
  }
});
// CONCATENATED MODULE: ./packages/kaihu-sms-code/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/kaihu-sms-code/src/main.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_mainvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/kaihu-sms-code/src/main.vue"
/* harmony default export */ var main = (component.exports);
// CONCATENATED MODULE: ./packages/kaihu-sms-code/index.js


main.install = function (Vue) {
  Vue.component(KaihuResult.KaihuSmsCode, main);
};

/* harmony default export */ var kaihu_sms_code = __webpack_exports__["default"] = (main);

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.split");

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.match");

/***/ })

/******/ });